import React, { MutableRefObject } from 'react';
import styles from './unlockAudio.module.scss';
import useLanguagesHooks from '../../../../../../Components/Languages/setLanguage-hooks';
import Button from '../../../../../../Components/Button/button';
import { ButtonTypes } from '../../../../../../Interfaces/componentTypes';
import { MusicNote } from '../../../../../../Assets/Icons';
import { useToastify } from '../../../../../../Hooks/hooks';

interface IProps {
    audioUnlocked: MutableRefObject<boolean>;
    notificationSoundRef?: MutableRefObject<HTMLAudioElement | null>;
    onClose: () => void
}

const UnlockAudioDialog: React.FC<IProps> = ({ audioUnlocked, notificationSoundRef, onClose }) => {
    const { t } = useLanguagesHooks();
    const { showToastError, showToastSuccess } = useToastify();

  const handleUnlockAudio = () => {
    if (!audioUnlocked.current && notificationSoundRef?.current) {
        const audioEl = notificationSoundRef.current;

        audioEl.preload = "auto";
        audioEl.muted = false;

        const tryPlay = async () => {
            try {
                await audioEl.play();
                setTimeout(() => {
                    if (!audioEl.paused) {
                        audioEl.pause();
                        audioEl.currentTime = 1000;
                    }
                    audioUnlocked.current = true;
                    showToastSuccess(t('My_Business.Unlock_Audio.Notify'));
                    onClose();
                }, 100);

            } catch (err) {
                audioUnlocked.current = false;
                showToastError(t('Toast.Error.Common'));
                onClose();
            }
        };

        tryPlay();
    }
};


    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <img src={MusicNote} alt='music.svg' />
                <p>
                    {t('My_Business.Unlock_Audio.Header')}
                </p>
            </div>
            <div className={styles.content}>
                <div className={styles.description}>
                    <p>
                        {t('My_Business.Unlock_Audio.Description')}
                    </p>
                </div>
                <div className={styles.buttonRow}>
                    <Button
                        buttonType={ButtonTypes.Primery}
                        title={t('My_Business.Unlock_Audio.Button')}
                        onClick={handleUnlockAudio}
                        buttonTitleStyle={styles.buttonTitle}
                    />
                </div>
            </div>

        </div>
    )
}

export default UnlockAudioDialog
